import { getProcessList } from '@/api/processList.js'
import lodash from 'lodash'

export const service = {
  getProcessList(data, type) {
    // const params = {
    //   process_base_status: data.process_base_status,
    //   process_config_type: data.process_config_type
    // }
    return new Promise((resolve, reject) => {
      getProcessList(data)
        .then((response) => {
          if (response) {
            const data = lodash.cloneDeep(response.records || [])
            const total = response.total
            if (type && type === '1') {
              for (let i = 0; i < data.length; i++) {
                if (data[i].process_base_status) {
                  if (data[i].process_base_status === 'Approval') {
                    data[i].process_status = '待审批'
                  } else if (data[i].process_base_status === 'Draft') {
                    data[i].process_status = '申请中'
                  } else if (data[i].process_base_status === 'Finish') {
                    data[i].process_status = '待发放'
                  } else if (data[i].process_base_status === 'ReturnDraft') {
                    data[i].process_status = '退回（申请中）'
                  } else if (data[i].process_base_status === 'Termination') {
                    data[i].process_status = '终止'
                  } else if (data[i].process_base_status === 'IsFinished') {
                    data[i].process_status = '待发放'
                  } else if (data[i].process_base_status === 'Finished') {
                    data[i].process_status = '已完成'
                  }
                }
                if (data[i].process_base_drafter) {
                  // data[i].process_base_drafter = JSON.parse(data[i].process_base_drafter)
                  data[i].drafterName = data[i].process_base_drafter.user_nick_name
                }
                if (data[i].process_base_table_message) {
                  data[i].process_base_table_message = JSON.parse(
                    data[i].process_base_table_message
                  )
                  data[i].projectType = '资金'
                  data[i].project_funding = data[i].process_base_table_message.project_funding // 项目资金
                  data[i].project_responsible_person =
                    data[i].process_base_table_message.project_responsible_person // 负责人
                  data[i].project_sponsor = data[i].process_base_table_message.project_sponsor // 负责
                  data[i].start_time = data[i].process_base_table_message.start_time
                  data[i].end_tima = data[i].process_base_table_message.end_time
                  // data[i].project_stauts = data[i].process_base_table_message.project_stauts
                }
              }
            } else {
              for (let i = 0; i < data.length; i++) {
                if (data[i].process_base_status) {
                  if (data[i].process_base_status === 'Approval') {
                    data[i].process_status = '待审批'
                  } else if (data[i].process_base_status === 'Draft') {
                    data[i].process_status = '申请中'
                  } else if (data[i].process_base_status === 'Finish') {
                    data[i].process_status = '待发放'
                  } else if (data[i].process_base_status === 'ReturnDraft') {
                    data[i].process_status = '退回（申请中）'
                  } else if (data[i].process_base_status === 'Termination') {
                    data[i].process_status = '终止'
                  }
                }
                if (data[i].process_base_drafter) {
                  // data[i].process_base_drafter = JSON.parse(data[i].process_base_drafter)
                  data[i].drafterName = data[i].process_base_drafter.user_nick_name
                }
                if (data[i].process_base_table_message) {
                  data[i].process_base_table_message = JSON.parse(
                    data[i].process_base_table_message
                  )
                  data[i].projectType = '活动'
                  data[i].project_funding = data[i].process_base_table_message.project_funding // 项目资金
                  data[i].project_responsible_person =
                    data[i].process_base_table_message.project_responsible_person // 负责人
                  data[i].project_sponsor = data[i].process_base_table_message.project_sponsor // 负责
                  data[i].start_time = data[i].process_base_table_message.start_time
                  data[i].end_tima = data[i].process_base_table_message.end_time
                  // data[i].project_stauts = data[i].process_base_table_message.activity_stauts
                }
              }
            }
            resolve({ data, total })
          } else {
            resolve({})
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
